export const DOUBT_ROUTES = {
  list: '/doubts',
  ask: '/doubts/ask',
  categories: '/doubts/categories',
  subcategories: '/doubts/subcategories',
  detail: '/doubts/detail',
};
